// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1X8Sd","header":"Messages_header__x6IRn"};